var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record_cool_div"},[_c('div',{staticClass:"container"},[_c('span',{staticStyle:{"--d":"2"}}),_c('span',{staticStyle:{"--d":"1"}}),_c('span',{staticStyle:{"--d":"0"}}),_c('span',{staticStyle:{"--d":"1"}}),_c('span',{staticStyle:{"--d":"2"}})])])
}]

export { render, staticRenderFns }